import { useEffect, useRef, useState } from "react";

// components
import PageLayout from "../../components/PageLayout"

// services
import axiosInstance from "../../api/apiClient";

// icons
import IconComponent from "../../components/Icon";
import { FaChevronDown } from "react-icons/fa";
import { FiX } from "react-icons/fi";

const EditBook = () => {
    const [showForm, setShowForm] = useState(false);
    const [editedBookInfo, setEditedBookInfo] = useState(null);
    const [searchString, setSearchString] = useState('');
    const [allBooks, setAllBooks] = useState([]);
    const [showBooks, setShowBooks] = useState(false);

    const [genreIsOpen, setGenreIsOpen] = useState(false);

    const [series, setSeries] = useState([]);
    const [genres, setGenres] = useState([]);

    const dropDownRef = useRef(null);
    const genreRef = useRef(null);

    const getAllBooks = async () => {
        await axiosInstance.get('/getAllBooks').then((data) => {
            setAllBooks(data);
        });
    };

    const editBook = () => {
       const formatData = {
            "title": editedBookInfo['Title'],
            "author_name": editedBookInfo['Author'],
            "author_l_f": editedBookInfo['Author l-f'],
            "additional_authors": editedBookInfo['Additional Authors'],
            "publisher": editedBookInfo['Publisher'],
            "binding": editedBookInfo['Binding'],
            "number_of_pages": editedBookInfo['Number of Pages'],
            "year_published": editedBookInfo['Year Published'],
            "original_publication_year": editedBookInfo['Original Publication Year'],
            "isbn": editedBookInfo['ISBN'],
            "isbn13": editedBookInfo['ISBN13'],
            "average_rating": editedBookInfo['Average Rating'],
            "genres": editedBookInfo['Genres'],
            "serie_id": editedBookInfo['Serie Id'] || null,
            "serie_position": editedBookInfo['Serie Position'],
            "cover_url": editedBookInfo['Cover URL'],
        }

        axiosInstance.post(`/admin/updateBook/${editedBookInfo['Book Id']}`, formatData).then(() => {
            getAllBooks();
            setShowForm(false);
        });
    };


    const toggleSelection = (genre) => {
        if (editedBookInfo['Genres'].includes(genre.genre_id)) {
            setEditedBookInfo({ ...editedBookInfo, 'Genres': editedBookInfo['Genres'].filter((g) => g !== genre.genre_id) });
        } else {
            setEditedBookInfo({ ...editedBookInfo, 'Genres': [...editedBookInfo['Genres'], genre.genre_id.toString()] });
        }
    };

    const removeGenre = (genre) => {
        setEditedBookInfo({ ...editedBookInfo, 'Genres': editedBookInfo['Genres'].filter((g) => g !== genre) });
    };

    const getSeries = async () => {
            const response = await axiosInstance.get('/getAllSeries');
            setSeries(response);
        }
    
    const getGenres = async () => {
        const response = await axiosInstance.get('/getAllGenres');
        const formatResponse = response.map((genre) => {
            return {
                genre_id: genre.genre_id.toString(),
                name: genre.name
            }
        }).sort((a, b) => a.name.localeCompare(b.name));
        setGenres(formatResponse);
    }

    useEffect(() => {
        getAllBooks();  
        getSeries();
        getGenres();

        const handleClickOutside = (event) => {
            if (dropDownRef.current && !dropDownRef.current.contains(event.target)) {
                setShowBooks(false);
            }

            if (genreRef.current && !genreRef.current.contains(event.target)) {
                setGenreIsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
        
    }, []);


    return (
        <PageLayout
            headerText="Edit book metadata"
            type="gear"
        >
            <div className="bg-white rounded-3xl shadow-lg p-4 min-h-20 mt-[40px] mb-[40px]">
                        <div className="relative group" ref={dropDownRef}>
                            <label htmlFor="search" className="block mb-2 text-sm font-medium text-gray-900">Search book to edit</label>
                            <input
                                className="inline-flex justify-center w-full px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-blue-500"
                                value={searchString}
                                id="search"
                                onChange={(e) => {setSearchString(e.target.value); setShowForm(false)}}
                                placeholder="Search book"
                                type="text"
                                onClick={() => setShowBooks(true)}

                            />
                            {
                                showBooks && (() => {
                                    const filteredBooks = allBooks.filter((book) =>
                                    Object.entries(book).some(([key, value]) => {
                                        const excludedFields = ['Genres', 'Date Read', 'Date Added'];
                                        if (excludedFields.includes(key)) return false;
                                        return String(value).toLowerCase().includes(searchString.toLowerCase());
                                    })
                                    );

                                    return (
                                    <div id="dropdown-menu" className="absolute w-full right-0 mt-2 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 p-1 space-y-1">
                                        {
                                        filteredBooks.length > 0 ? (
                                            filteredBooks.map((book, idx) => (
                                            <div
                                                key={idx}
                                                className="block px-4 py-2 text-gray-700 hover:bg-gray-100 active:bg-blue-100 cursor-pointer rounded-md"
                                                onClick={() => {
                                                setShowForm(true);
                                                setEditedBookInfo(book);
                                                setSearchString(`${book['Title']}`);
                                                setShowBooks(false);
                                                }}
                                            >
                                                {book['Title']} - {book['Author']}
                                            </div>
                                            ))
                                        ) : (
                                            <div className="block px-4 py-2 text-gray-500 italic">
                                            No books found
                                            </div>
                                        )
                                        }
                                    </div>
                                    );
                                })()
                            }
                        </div> 

                        {
                            showForm && 
                            <form
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    editBook();
                                }}
                            >
                                <hr className="my-6 shadow"/>
                                {/* title and id */}
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div>
                                        <label htmlFor="title" className="block mb-2 text-sm font-medium text-gray-900">
                                            Title
                                        </label>
                                        <input
                                            type="text"
                                            id="title"
                                            value={editedBookInfo['Title']}
                                            onChange={(e) => setEditedBookInfo({...editedBookInfo, 'Title': e.target.value})}
                                            className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                            required
                                        />
                                    </div>
                                    <div>
                                        <label
                                            htmlFor="id"
                                            className="block mb-2 text-sm font-medium text-gray-900"
                                        >
                                            ID
                                        </label>
                                        <input
                                            value={editedBookInfo['Book Id']}
                                            type="text"
                                            id="id"
                                            className="disabled:cursor-not-allowed bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                            placeholder="ID"
                                            required
                                            readOnly
                                            disabled
                                        />
                                    </div>
                                </div>
                                {/* author and author l-f */}
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div>
                                        <label
                                            htmlFor="author"
                                            className="block mb-2 text-sm font-medium text-gray-900 mt-2"
                                        >
                                            Author
                                        </label>
                                        <input
                                            type="text"
                                            id="author"
                                            value={editedBookInfo['Author']}
                                            onChange={(e) => setEditedBookInfo({...editedBookInfo, 'Author': e.target.value})}
                                            className=" border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                            required
                                        />
                                    </div>
                                    <div>
                                        <label
                                            htmlFor="authorlf"
                                            className="block mb-2 text-sm font-medium text-gray-900 mt-2"
                                        >
                                            Author l-f
                                        </label>
                                        <input
                                            value={editedBookInfo['Author l-f']}
                                            onChange={(e) => setEditedBookInfo({...editedBookInfo, 'Author l-f': e.target.value})}
                                            type="text"
                                            id="authorlf"
                                            className="border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                            placeholder="Author l-f"
                                            required
                                        />
                                    </div>
                                </div>
                                {/* additional authors and publisher */}
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div>
                                        <label
                                            htmlFor="Additional Authors"
                                            className="block mb-2 text-sm font-medium text-gray-900 mt-2"
                                        >
                                            Additional Authors
                                        </label>
                                        <input
                                            value={editedBookInfo['Additional Authors']}
                                            onChange={(e) => setEditedBookInfo({...editedBookInfo, 'Additional Authors': e.target.value})}
                                            type="text"
                                            id="Additional Authors"
                                            className="border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                            placeholder="Additional Authors"

                                        />
                                    </div>
                                    <div>
                                        <label
                                            htmlFor="Publisher"
                                            className="block mb-2 text-sm font-medium text-gray-900 mt-2"
                                        >
                                            Publisher
                                        </label>
                                        <input
                                            value={editedBookInfo['Publisher']}
                                            onChange={(e) => setEditedBookInfo({...editedBookInfo, 'Publisher': e.target.value})}
                                            type="text"
                                            id="Publisher"
                                            className="border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                            placeholder="Publisher"
                                            required
                                        />
                                    </div>          
                                </div>
                                {/* binding and number of pages */}
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div>
                                        <label
                                            htmlFor="Binding"
                                            className="block mb-2 text-sm font-medium text-gray-900 mt-2"
                                        >
                                            Binding
                                        </label>
                                        <input
                                            value={editedBookInfo['Binding']}
                                            onChange={(e) => setEditedBookInfo({...editedBookInfo, 'Binding': e.target.value})}
                                            type="text"
                                            id="Binding"
                                            className="border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                            placeholder="Binding"

                                        />
                                    </div>
                                    <div>
                                        <label
                                            htmlFor="Number of Pages"
                                            className="block mb-2 text-sm font-medium text-gray-900 mt-2"
                                        >
                                            Number of Pages
                                        </label>
                                        <input
                                            value={editedBookInfo['Number of Pages']}
                                            onChange={(e) => setEditedBookInfo({...editedBookInfo, 'Number of Pages': e.target.value})}
                                            type="text"
                                            id="Number of Pages"
                                            className="border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                            placeholder="Number of Pages"
                                            required
                                        />
                                    </div>          
                                </div>
                                {/* year published and original publication year */}
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div>
                                        <label
                                            htmlFor="Year Published"
                                            className="block mb-2 text-sm font-medium text-gray-900 mt-2"
                                        >
                                            Year Published
                                        </label>
                                        <input
                                            value={editedBookInfo['Year Published']}
                                            onChange={(e) => setEditedBookInfo({...editedBookInfo, 'Year Published': e.target.value})}
                                            type="text"
                                            id="Year Published"
                                            className="border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                            placeholder="Year Published"

                                        />
                                    </div>
                                    <div>
                                        <label
                                            htmlFor="Original Publication Year"
                                            className="block mb-2 text-sm font-medium text-gray-900 mt-2"
                                        >
                                            Original Publication Year
                                        </label>
                                        <input
                                            value={editedBookInfo['Original Publication Year']}
                                            onChange={(e) => setEditedBookInfo({...editedBookInfo, 'Original Publication Year': e.target.value})}
                                            type="text"
                                            id="Original Publication Year"
                                            className="border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                            placeholder="Original Publication Year"
                                        />
                                    </div>          
                                </div>
                                {/* ISBN and ISBN13 */}
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div>
                                        <label
                                            htmlFor="ISBN"
                                            className="block mb-2 text-sm font-medium text-gray-900 mt-2"
                                        >
                                            ISBN
                                        </label>
                                        <input
                                            value={editedBookInfo['ISBN']}
                                            onChange={(e) => setEditedBookInfo({...editedBookInfo, 'ISBN': e.target.value})}
                                            type="text"
                                            id="ISBN"
                                            className="border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                            placeholder="ISBN"

                                        />
                                    </div>
                                    <div>
                                        <label
                                            htmlFor="ISBN13"
                                            className="block mb-2 text-sm font-medium text-gray-900 mt-2"
                                        >
                                            ISBN13
                                        </label>
                                        <input
                                            value={editedBookInfo['ISBN13']}
                                            onChange={(e) => setEditedBookInfo({...editedBookInfo, 'ISBN13': e.target.value})}
                                            type="text"
                                            id="ISBN13"
                                            className="border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                            placeholder="ISBN13"
                                        />
                                    </div>          
                                </div>
                                {/* average rating and genres */}
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div>
                                        <label
                                            htmlFor="Average Rating"
                                            className="block mb-2 text-sm font-medium text-gray-900 mt-2"
                                        >
                                            Average Rating
                                        </label>
                                        <input
                                            value={editedBookInfo['Average Rating']}
                                            onChange={(e) => setEditedBookInfo({...editedBookInfo, 'Average Rating': e.target.value})}
                                            type="number"
                                            step={"0.1"}
                                            id="Average Rating"
                                            className="border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                            placeholder="Average Rating"
                                        />
                                    </div>
                                    <div>
                                        <label className="block mb-2 text-sm font-medium text-gray-900 mt-2">Genres</label>
                                        <div className="relative" ref={genreRef}>
                                            <div
                                                className="flex items-center border border-gray-300 text-gray-900 bg-white text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                                onClick={() => setGenreIsOpen(!genreIsOpen)}
                                            >
                                                {editedBookInfo['Genres'].length === 0 && (
                                                    <span className="text-gray-400">Select genre...</span>
                                                )}
                                                <div className='gap-2 flex'>
                                                    {editedBookInfo['Genres'].map((genre) => (
                                                        <span
                                                            key={genre}
                                                            className="flex items-center bg-[#8784D8] text-white text-xs px-2 py-1 rounded-full"
                                                        >
                                                            {genres.find((g) => g.genre_id === genre.toString())?.name}
                                                            <IconComponent
                                                                icon={FiX}
                                                                onClick={() => {
                                                                    removeGenre(genre);
                                                                }}
                                                                color={'white'}
                                                                className="w-4 h-4 ml-1 cursor-pointer"
                                                            />
                                                        </span>
                                                    ))}
                                                </div>
                                                <IconComponent width={"1em"} icon={FaChevronDown} className="text-gray-500 ml-auto text-xs" />
                                            </div>
            
                                            {genreIsOpen && (
                                                <ul className="absolute z-10 mt-1 w-full bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-auto">
                                                    {genres.map((genre) => (
                                                    <li
                                                        key={genre.genre_id}
                                                        className={`px-4 py-2 cursor-pointer hover:bg-indigo-100 ${
                                                        editedBookInfo['Genres'].includes(genre.genre_id) ? 'bg-[#8784D8] text-white' : ''
                                                        }`}
                                                        onClick={() => toggleSelection(genre)}
                                                    >
                                                        {genre.name}
                                                    </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </div>
                                    </div> 
                                </div>
                                {/* series and serie position */}
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                                    <div>
                                        <label
                                            htmlFor="Serie"
                                            className="block mb-2 text-sm font-medium text-gray-900 mt-2"
                                        >
                                            Serie
                                        </label>
                                        <select
                                            value={editedBookInfo['Serie Id']}
                                            onChange={(e) => setEditedBookInfo({...editedBookInfo, 'Serie Id': e.target.value})}
                                            id="Serie"
                                            className="border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                        >
                                            <option value="">No serie selected</option>
                                            {series.map((serie) => (
                                                <option key={serie.serie_id} value={serie.serie_id}>
                                                    {serie.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div>
                                        <label
                                            htmlFor="Serie Position"
                                            className="block mb-2 text-sm font-medium text-gray-900 mt-2"
                                        >
                                            Serie Position
                                        </label>
                                        <input
                                            value={
                                                editedBookInfo["Serie Position"] === undefined
                                                ? ''
                                                : editedBookInfo["Serie Position"]
                                            }
                                            onChange={(e) => setEditedBookInfo({...editedBookInfo, 'Serie Position': parseInt(e.target.value) || undefined})}
                                            type="number"
                                            id="Serie Position"
                                            className="border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                            placeholder="Serie Position"
                                        />
                                    </div>
                                </div>
                                <div className="grid grid-cols-1 gap-6">
                                    <div>

                                        <label htmlFor="Cover URL" className="block mb-2 text-sm font-medium text-gray-900 mt-2">
                                            Cover URL
                                        </label>
                                        <input
                                            value={editedBookInfo['Cover URL']}
                                            onChange={(e) => setEditedBookInfo({...editedBookInfo, 'Cover URL': e.target.value})}
                                            type="text"
                                            id="Cover URL"
                                            className="border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                            placeholder="Cover URL"

                                        />
                                    </div>
                                </div>

                                <button
                                    type="submit"
                                    className="text-white mt-4 bg-[#8784D8] hover:bg-[#6b67c9] focus:ring-4 focus:outline-none focus:ring-[#6b67c9] font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                                >
                                    Edit Book
                                </button>
                            </form>
                        }
                    </div>
        </PageLayout>
    )
    
}

export default EditBook